module.exports = __webpack_public_path__ + "media/views/about/images/phone-b007d82c58f4097f4a0a1bbce3c6c369.svg";